<template>
  <b-modal @hidden="$emit('cancel')" @ok.prevent="setWorkday" v-model="localShow">
    <h4 slot="modal-title">{{ workday.date }}</h4>
    <b-form>
      <b-row>
        <b-col cols="6">
          <b-form-group>
            <span slot="label">Początek pracy</span>

            <time-select
              v-if="localShow"
              :set="start"
              :disabled="!check.start"
              :display-set-now="true"
              @time="
                value => {
                  start = value;
                }
              "
            ></time-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <span slot="label">
              Koniec pracy
              <b-checkbox v-model="check.end" class="float-right"></b-checkbox>
            </span>
            <time-select
              v-if="localShow"
              :set="end"
              :disabled="!check.end"
              :display-set-now="true"
              @time="
                value => {
                  end = value;
                }
              "
            ></time-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <span slot="label">
            Nadgodziny &nbsp;
            <b-checkbox v-model="check.overtime" class="float-right"></b-checkbox>
          </span>
        </b-col>
        <b-col cols="6">
          <time-select
            v-if="localShow"
            :set="overtime"
            :disabled="!check.overtime"
            @time="
              value => {
                overtime = value;
              }
            "
          ></time-select>
        </b-col>
      </b-row>
    </b-form>
    <span slot="modal-cancel">Anuluj</span>
    <span slot="modal-ok">Zapisz</span>
  </b-modal>
</template>
<script>
import TimeSelect from '@/components/TimeSelect.vue';
import { WorkdayResource } from '@/resources/workday.resource';
import { toClock } from '@/utils';

export default {
  props: ['show', 'workday'],
  components: { TimeSelect },
  data() {
    return {
      check: { start: true, end: false, overtime: false },
      localShow: false,
      start: null,
      end: null,
      overtime: '1:00',
      date: ''
    };
  },
  methods: {
    setWorkdayTime(wd) {
      this.start = this.timeToString(wd.start);
      this.end = this.timeToString(wd.end);
      this.overtime = this.timeToString(wd.overtimeLimit);
      this.check.overtime = wd.overtimeAccepted;
      if (wd.end) {
        this.check.end = true;
      } else {
        this.check.end = false;
      }
    },
    async setWorkday(event) {
      let wdstart = null;
      let wdend = null;
      let wotime = null;
      if (this.check.start) {
        wdstart = this.parseTime(this.start);
      }
      if (this.check.end) {
        wdend = this.parseTime(this.end);
      }
      if (this.check.overtime) {
        wotime = this.parseTime(this.overtime);
      }
      try {
        await WorkdayResource.update(this.workday.id, wdstart, wdend, this.check.overtime, wotime);
        this.$notify({ type: 'success', title: 'Sukces', text: 'Pomyślnie zmieniono godziny pracy' });
        this.$emit('changed');
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas edycji godzin pracy' });
      }
    },
    parseTime(time) {
      if (!time) {
        return 0;
      }
      const split = time.split(':').map(n => parseInt(n, 10));
      return split[0] * 60 + split[1];
    },
    timeToString(time) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      return `${toClock(hours)}:${toClock(minutes)}`;
    }
  },
  mounted() {
    this.setWorkdayTime(this.workday);
  },
  watch: {
    show(show) {
      this.localShow = show;
    },
    workday(wd) {
      this.setWorkdayTime(wd);
      this.date = wd.date;
    }
  }
};
</script>
